<div class="mx-auto flex h-full w-full flex-col rounded-md border border-border-3 bg-white">
  <app-konva-webgl-check>
    <app-konva-editor
      class="max-h-[calc(100%-56px)] grow"
      className="p-4 h-full w-full"
      (navigateToImagePage)="onNavigateToImagePage()"
      (navigateToManage)="onNavigateToManage()"
      (categoryCreated)="onCategoryCreated($event)"
    />
  </app-konva-webgl-check>

  <div class="my-2 flex gap-6 px-5">
    <button mat-button (click)="back.emit()">
      {{ 'common.back' | translate }}
    </button>
    <!-- <app-button class="!leading-none" mainClass="p-3 text-xs font-semibold" > -->
    <!-- </app-button> -->
    <button mat-flat-button (click)="onContinue()" [disabled]="loading() || continueDisabled()">
      {{ (loading() ? 'common.creating...' : 'common.continue') | translate }}
    </button>
    <!-- <app-button -->
    <!--   class="!leading-none" -->
    <!--   mainClass="p-3 text-xs font-semibold" -->
    <!--   [color]="ButtonColor.primary" -->
    <!-- > -->
    <!-- </app-button> -->

    @if (baseCategory()) {
      <button mat-button (click)="onClear()">
        {{ 'common.clear' | translate }}
      </button>
      <!-- <app-button class="!leading-none ml-auto" mainClass="p-3 text-xs font-semibold" > -->
      <!-- </app-button> -->
    }
  </div>
</div>
